<template>
    <v-card color="bg lighten-4">
        <v-card-text>
            <ol class="mx-3">
                <li v-for="(hint, i) in hints" :key="'hint_ar' + i" class="my-2"><b class="text-subtitle-1 type--text">{{ hint }}</b></li>
            </ol>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: ['hints']
}
</script>